


















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { isValidUsername } from '@/utils/validate'
import { getToken } from '@/utils/cookies'
import {encryption} from "@/utils/aesEncrypt";
import { iv, key} from "@/utils/validate";
@Component({
  name: 'Login'
})
export default class extends Vue {
  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!value) {
      callback(new Error('请输入用户名'))
    } else {
      callback()
    }
  }
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error('密码必须在6位以上'))
    } else {
      callback()
    }
  }
  private loginForm = {
    username: '',
    password: ''
  } as {
    username: String
    password: String
  }

  loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }
  private loading = false
  private redirect?: string

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
  }

  // 登录
  private handleLogin() {
    let token = getToken()
    if (token) {
      this.$router.push('/')
    } else {
      (this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          this.loading = true
          const user = JSON.parse(JSON.stringify(this.loginForm));
          user.password = encryption(this.loginForm.password, key, iv)
          await UserModule.Login(user as any)
            .then((res: any) => {
              if (String(res.code) === '1') {
                this.$router.push('/')
              } else {
                // this.$message.error(res.msg)
                this.loading = false
              }
            })
            .catch(() => {
              // this.$message.error('用户名或密码错误！')
              this.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
